import React, { useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
// import React, { useEffect } from 'react';
import { auth, signInWithEmailAndPassword, sendEmailVerification } from '../firebase/config';
import CustomCursor from '../components/CustomCursor';
import { playBillSound,playClickSound, playSuccessSound, playErrorSound, playLoadingSound, stopLoadingSound } from '../utils/soundEffects';
import './LoginPage.css';
import logoImage from '../images/skullture_white.png';
const LoginPage = () => {
  const navigate = useNavigate();
    


  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
useEffect(() => {
    // Create particles
    for(let i = 0; i < 50; i++) {
      const particle = document.createElement('div');
      particle.classList.add('particle');
      particle.style.left = Math.random() * 100 + '%';
      particle.style.animationDelay = Math.random() * 8 + 's';
      particle.style.animationDuration = 5 + Math.random() * 5 + 's';
      particle.style.width = Math.random() * 3 + 1 + 'px';
      particle.style.height = particle.style.width;
      document.body.appendChild(particle);
    }
    
    return () => {
      document.querySelectorAll('.particle').forEach(p => p.remove());
    };
  }, []);
  const handleLogin = async (e) => {
    e.preventDefault();
    playBillSound();
    
    if (!email || !password) {
      setError('⛧ Enter email and password ⛧');
      playErrorSound();
      return;
    }
    
    setLoading(true);
    playLoadingSound();
    setError('');
    
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      if (!user.emailVerified) {
        setError('⛧ Please verify your email before logging in. Check your inbox. ⛧');
        playErrorSound();
        stopLoadingSound();
        setLoading(false);
        return;
      }
      
      stopLoadingSound();
      // playSuccessSound();

      setTimeout(() => {
        // playThunderSound();
        sessionStorage.setItem('skullture_auth', 'verified');
        sessionStorage.setItem('skullture_user', email);
        navigate('/');
      }, 500);
    } catch (err) {
      stopLoadingSound();
      playErrorSound();
      let message = '⛧ Authentication failed ⛧';
      if (err.code === 'auth/user-not-found') message = '⛧ User not found ⛧';
      if (err.code === 'auth/wrong-password') message = '⛧ Incorrect password ⛧';
      if (err.code === 'auth/invalid-email') message = '⛧ Invalid email ⛧';
      if (err.code === 'auth/too-many-requests') message = '⛧ Too many attempts. Try again later ⛧';
      setError(message);
      setLoading(false);
    }
  };

  const handleResendVerification = async () => {
    if (!email) {
      setError('⛧ Enter your email address first ⛧');
      playErrorSound();
      return;
    }
    
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      await sendEmailVerification(userCredential.user);
      await auth.signOut();
      setError('✓ Verification email sent! Please check your inbox.');
      // playSuccessSound();
    } catch (err) {
      setError('⛧ Could not send verification. Try again. ⛧');
      playErrorSound();
    }
  };

  return (
    <div className="login-page">
      <CustomCursor />
      <div className="auth-card">
        <div className="glitch-text">  <img src={logoImage} alt="SKULLTURE"
            onError={(e) => {
              e.target.style.display = 'none';
              const parent = e.target.parentElement;
              const span = document.createElement('span');
              span.className = 'logo-text-fallback';
              span.textContent = 'SKULLTURE';
              parent.insertBefore(span, e.target);
            }}
          /></div>
        <div className="auth-title">ACCESS REQUIRED</div>
        <div className="auth-sub">SIGNAL VERIFICATION PROTOCOL</div>

        <form onSubmit={handleLogin}>
          <div className="input-group">
            <div className="input-label">EMAIL ADDRESS</div>
            <input 
              type="email" 
              className="auth-input" 
              placeholder="identity@skullture.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-group">
            <div className="input-label">PASSWORD</div>
            <input 
              type="password" 
              className="auth-input" 
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="auth-error" id="loginErrorMsg">{error}</div>
          
          {error && error.includes('verify') && (
            <div className="resend-link">
              Not verified? <span onClick={handleResendVerification}>Resend verification email</span>
            </div>
          )}

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? <span className="spinner"></span> : '⟡ AUTHENTICATE ⟡'}
          </button>
        </form>
        
        <div className="auth-link" onClick={() => {
          playClickSound();
          navigate('/entry');
        }}>← BACK TO ENTRY GATE</div>
        <div className="auth-link" onClick={() => {
          playClickSound();
          navigate('/signup');
        }}>← NO ACCOUNT? SIGNUP →</div>
      </div>
    </div>
  );
};

export default LoginPage;